import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";

const TableTipoProductos = ({
  tipoProductos,
  loading,
  header,
  globalFilterValue,
  nombreEmpresa,
}) => {
  return (
    <DataTable
      value={tipoProductos}
      loading={loading}
      header={header}
      globalFilter={globalFilterValue}
      className="p-datatable-gridlines mt-3"
      showGridlines
      paginator
      rows={10}
      rowsPerPageOptions={[10, 20, 50, 100]}
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
      currentPageReportTemplate={`Mostrando {first} a {last} de {totalRecords} tipos de productos de ${nombreEmpresa}`}
      dataKey="id"
      emptyMessage="No se encontraron tipos de producto."
      stripedRows="true"
      id="tipoProductoTable"
      globalFilterFields={["descripcion", "unidad"]}
      tableStyle={{
        tableLayout: "fixed",
        width: "100%",
        minWidth: "1000px",
      }}
      scrollable
      scrollHeight="57vh"
      reorderableColumns
      resizableColumns
      columnResizeMode="fit"
    >
      <Column field="descripcion" header="Descripción" sortable />

      <Column
        field="unidad"
        header="Unidad"
        sortable
        body={(rowData) => {
          if (rowData.unidad === "m**2") return "m²";
          if (rowData.unidad === "m**3") return "m³";
          return rowData.unidad;
        }}
      />

      <Column
        field="tarifa"
        header="Tarifa"
        sortable
        sortField="tarifa.tarifa_base"
        dataType="numeric"
        body={(rowData) => {
          if (rowData.tarifa && rowData.tarifa.tarifa_base != null) {
            return rowData.tarifa.tarifa_base;
          }
          return "-";
        }}
      />

      <Column
        field="empresa"
        header="Empresa"
        sortable
        body={(rowData) => {
          return rowData.nombre_empresa;
        }}
      />

      <Column
        field="activo"
        header="Activo"
        body={(rowData) => (
          <>
            {rowData.activo ? (
              <Button
                icon="pi pi-check"
                className="p-button-rounded p-button-success p-button mr-2 mb-2 mt-2"
                outlined
              />
            ) : (
              <Button
                icon="pi pi-times"
                className="p-button-rounded p-button-danger p-button mr-2 mb-2 mt-2"
                onClick={() => {}}
                outlined
              />
            )}
          </>
        )}
        sortable
      />
    </DataTable>
  );
};

export default TableTipoProductos;
